<template>
  <div class="member-homework-index">
    <div class="selectAttr">
      <el-dropdown
        @command="handleSelectCourseAttr"
        @visible-change="handleVisibelChange"
        :class="{ onshowUpIcon: showDropUp }"
      >
        <span class="el-dropdown-link">
          <span :class="{ onColor: attrTitleOnColor }">
            {{ attrTitle }}
          </span>
          <i class="el-icon-caret-bottom" :class="{ onColor: attrTitleOnColor }"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in course_attrs"
            :key="item.name"
            :command="item"
            :class="{ onBackGround: item.name === attrTitle }"
          >
            <span :class="{ onColor: item.name === attrTitle }">
              {{ item.name }}
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-tabs class="el-tabs-common" v-model="curTab" @tab-click="onChangeTab">
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :name="item.name"
        :label="item.label + '（' + item.num + '）'"
      ></el-tab-pane>
    </el-tabs>
    <el-scrollbar style="padding-bottom: 20px" :style="scrollStyle">
      <!-- <div class="search" v-if="tabs.find(t => t.name == curTab).num > 0">
        <el-input
          v-model="search.title"
          placeholder="请输入课程关键字"
        ></el-input>
        <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
        <el-button type="default" size="mini" @click="onReset">重置</el-button>
      </div> -->
      <list
        ref="list"
        url="/api/app/user/homework/list"
        :alwaysShowPager="false"
        :search="search"
        @page-load="onPageLoad"
      >
        <template>
          <div class="list" v-if="homeworks.length > 0">
            <div class="homework-item" shadow="hover" v-for="item in homeworks" :key="item.hw_id">
              <div class="left">
                <div class="title-wrap">
                  <span class="status">
                    {{ item.subject }}
                  </span>
                  <span class="title">{{ item.hw_name }}</span>
                </div>
                <template v-if="item.hw_type === 1">
                  <div class="info">所属课程：{{ item.title }}</div>
                  <div class="info">所属课节：{{ item.periods_name || '-' }}</div>
                </template>
                <template v-else>
                  <div class="info">
                    所属课次：
                    <span class="pad4" v-if="$store.getters.getSwitch('classify')">
                      {{ item.arrange_detail.classify_name || '' }}
                    </span>
                    <span class="pad4" v-if="$store.getters.getSwitch('grade')">
                      {{ item.arrange_detail.grade_name || '' }}
                    </span>
                    <span class="pad4">
                      {{ item.arrange_detail.subject_name || '' }}
                    </span>
                    <span>
                      {{ item.arrange_detail.arrange_time }}
                    </span>
                  </div>
                  <div class="info">课次类型：{{ getClassType(item.hw_class_type) }}</div>
                </template>
                <div class="hw_tip" v-html="getHomeworkTip(item)" />
              </div>
              <div class="right">
                <div class="link-wrap">
                  <div @click.stop="handleGoHomework(item)" class="btn">
                    {{
                      item.status === 1
                        ? item.is_continue_answer
                          ? '继续作答'
                          : '立即作答'
                        : item.status === 2
                        ? '答题情况'
                        : item.status === 6
                        ? '作答结果'
                        : '查看结果'
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <slot name="empty" v-else>
            <EvaluationEmpty
              :text="
                homeworks.length > 0 && curTab != 0
                  ? '暂无' + tabs.find((t) => t.name == curTab).label + '作业哦'
                  : '暂无作业哦'
              "
            ></EvaluationEmpty>
          </slot>
        </template>
      </list>
    </el-scrollbar>
  </div>
</template>

<script>
import EvaluationEmpty from '@/modules/stu/views/member/EvaluationEmpty.vue';
import { PeriodsType } from '@/utils/enums.js';

export default {
  name: 'HomeworkList',
  components: { EvaluationEmpty },
  props: {
    classId: {},
    props: {
      isFromMember: {
        type: Boolean,
        default: true,
      },
    },
  },
  data() {
    return {
      showDropUp: false,
      attrTitle: '',
      attrTitleOnColor: false,
      course_attrs: [],
      curTab: '1',
      tabs: [
        { label: '待提交', name: '1', num: 0 },
        { label: '待批改', name: '2', num: 0 },
        { label: '待订正', name: '6', num: 0 },
        { label: '已完成', name: '7', num: 0 },
      ],
      homeworks: [],
      search: {
        title: '',
        status: 1,
        class_id: this.classId,
        subject: '',
        form: '',
      },
    };
  },
  computed: {
    scrollStyle() {
      return this.isFromMember
        ? `height:calc('${$store.state.memberLeftHeight}px - 76px - 99px);`
        : '';
    },
  },
  created() {
    this.getCourseAttr();
    this.getTabListNum();
  },
  methods: {
    handleVisibelChange(val) {
      if (val) {
        this.showDropUp = true;
        this.attrTitleOnColor = true;
      } else {
        this.showDropUp = false;
        this.attrTitleOnColor = false;
      }
    },
    async getCourseAttr() {
      const res = await this.$http.get('/api/app/study/courseAttr');
      if (res) {
        this.course_attrs = res;
        const defaultAttr = res[0];
        this.attrTitle = defaultAttr.name;
        this.search.subject = defaultAttr.subject;
        this.search.form = defaultAttr.form;
      }
    },
    getHomeworkTip(item) {
      const tipMap = {
        '1-0': '快来验证一下学习效果吧',
        1: '加把劲儿，就快答完了',
        2: '快马加鞭批改中...',
        6: `你找到了<span style="color: red">${item.wrong_count}道错题</span>，快去订正吧`,
        7: '恭喜你完成本次作业',
      };
      let status = item.status;
      // 1待提交「开始作答」「继续作答」、2待批改「答题情况」、6待订正「作答结果」、7已完成「查看结果」。
      if (status === 1) {
        // 0显示「开始作答」，非0=》「继续作答」
        if (item.is_continue_answer === 0) {
          status = '1-0';
        }
      }
      return tipMap[status];
    },
    formatDataToPlus(data) {
      return +data > 99 ? '99+' : data;
    },
    async getTabListNum() {
      const data = await this.$http.get('/api/app/user/homework/listNum', {
        class_id: this.classId,
        subject: this.search.subject,
        form: this.search.form,
      });
      this.tabs.find((t) => t.name == 1).num = this.formatDataToPlus(data.no_submit_num);
      this.tabs.find((t) => t.name == 2).num = this.formatDataToPlus(data.submit_num);
      this.tabs.find((t) => t.name == 6).num = this.formatDataToPlus(data.wait_correction_num);
      this.tabs.find((t) => t.name == 7).num = this.formatDataToPlus(data.finish_num);
    },
    handleSelectCourseAttr(command) {
      this.attrTitle = command.name;
      this.attrTitleOnColor = true;
      this.search.subject = command.subject;
      this.search.form = command.form;
      this.getTabListNum();
      this.onSearch();
    },
    onChangeTab({ name }) {
      this.search.status = name;
      this.onSearch();
      this.getTabListNum(0);
    },
    onPageLoad({ list }) {
      this.homeworks = list;
      this.$emit('load');
    },
    onSearch() {
      this.$refs.list.searchRefresh();
    },
    // onReset() {
    //   this.search.title = "";
    //   this.onSearch();
    // },
    getClassType(type) {
      return PeriodsType.getValue(type) || '--';
    },
    async handleGoHomework(homework) {
      if (homework.status === 0) {
        this.$info('作业未解锁');
        return;
      }

      //作业可访问性检查
      if (homework.id === 0) {
        await this.$http.get('/api/app/user/homework/detail', {
          hw_id: homework.hw_id,
        });
      } else {
        await this.$http.post('/api/app/user/homework/scantron', {
          report_id: homework.id,
        });
      }

      //作业可访问性检查接口200时执行下面
      this.$router.push({
        name:
          homework.status === 1
            ? homework.is_continue_answer
              ? 'HomeworkDo'
              : 'HomeworkIntro'
            : 'HomeworkAnalysis',
        query: {
          id: homework.id,
          hw_id: homework.hw_id,
          type: homework.status === 6 ? 'correct' : undefined,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .onshowUpIcon .el-icon-caret-bottom:before {
  content: '\E78f';
}
::v-deep .el-tabs-common .el-tabs__item {
  margin-right: 56px;
  color: #1a1a1a;
}
::v-deep .el-tabs-common .el-tabs__item.is-active::after {
  height: 2px;
  width: 24px !important;
  border-radius: 2px;
  background: #f4242e;
  left: 50% !important;
  transform: translateX(-75%) !important;
}
::v-deep .onColor {
  color: #f4242e;
}
::v-deep .onBackGround {
  background-color: rgba(244, 36, 46, 0.1) !important;
}
::v-deep .el-dropdown-menu__item:hover {
  background-color: #fff;
}
.member-homework-index {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 10px 0 30px 0;

  .selectAttr {
    position: absolute;
    top: 93px;
    right: 32px;
    top: -65px;
    display: flex;
    padding-top: 15px;
    justify-content: flex-end;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    .onColor {
      color: #f4242e;
    }
  }

  ::v-deep {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .list {
    padding-bottom: 30px;
  }

  .homework-item {
    padding: 20px 0 24px 0;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px solid #ededed;
    display: flex;
    align-items: center;

    .left {
      flex-grow: 1;
    }

    .title-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 17px;
      .status {
        border: 1px solid #f4272f;
        border-radius: 4px;
        font-size: 12px;
        line-height: 17px;
        color: #f4242e;
        padding: 4px 8px;
        text-align: center;
        margin-right: 8px;
        font-weight: 500;
      }
    }

    .hw_tip {
      font-size: 14px;
      line-height: 22px;
      color: #999;
      font-weight: 400;
    }

    .title {
      font-size: 16px;
      font-weight: 500;
    }

    .info {
      font-size: 14px;
      line-height: 20px;
      color: #1a1a1a;
      margin-bottom: 8px;
      font-weight: 400;
      &:last-child {
        margin-bottom: 0;
      }

      .line {
        margin: 0 10px;
      }

      .red {
        color: red;
      }

      .pad4 {
        padding-right: 4px;
      }
    }

    .right {
      width: 160px;
      display: flex;
      flex-direction: column;
    }

    .link-wrap {
      display: flex;
      justify-content: flex-end;
      .btn {
        width: 104px;
        height: 40px;
        background: linear-gradient(90.99deg, #ff5858 11.16%, #ff6b00 60.83%, #ff3743 102.99%);
        border-radius: 30px;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        color: white;
        box-sizing: border-box;
        cursor: pointer;
      }
    }

    .score {
      width: 42px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 1;
      text-align: center;
      color: #ff2d28;
      background-image: url('~@/assets/images/homework/score-line@2x.png');
      background-position: center bottom;
      background-size: 42px 13px;
      background-repeat: no-repeat;
      margin-right: 11px;
    }
  }
  .homework-item:first-child {
    padding-top: 8px;
  }
}
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  position: relative;

  img {
    width: 484px;
  }

  .text {
    font-size: 16px;
    color: #666666;
    position: absolute;
    bottom: 91px;
  }
}
.el-tabs-common {
  ::v-deep {
    .el-tabs__item.is-active::after {
      width: 50px;
      transform: none;
      left: 11px;
    }
  }
}
.search {
  display: flex;
  align-items: center;

  ::v-deep {
    .el-input {
      width: 219px;
      margin-right: 10px;
    }
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
